export default __webpack_public_path__ + "288ac2269f6e34ec09038e54518dbba6.png";